import { UseQueryResult } from "react-query";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { RemoteApiError } from "../useRemote/types";

export type VehicleTripLog = {
  id: number;
  vehicleBookingId: number;
  vehicleInventoryId: number;
  driverId: string;
  tripReason: string;
  checkOutTime: string; // ISO date string
  checkOutOdometer: number;
  checkOutNotes: string | null;
  checkOutPhotos: string[] | null;
  checkInTime: string | null; // ISO date string
  checkInOdometer: number | null;
  checkInNotes: string | null;
  checkInPhotos: string[] | null;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
};

/**
 * Fetches trip log entries for a vehicle (GET /fleet/vehicles/:vehicleId/logbook).
 * Only runs when vehicleId is set.
 */
export function useRemoteFetchFleetLogbook(
  vehicleId: number | null
): UseQueryResult<VehicleTripLog[], RemoteApiError> {
  const result = useRemoteQuery<VehicleTripLog[], RemoteApiError>({
    queryKey: ["fleet", "vehicles", vehicleId, "logbook"],
    url: `/fleet/vehicles/${vehicleId}/logbook`,
    enabled: vehicleId != null
  });

  return { ...result, data: result.data } as UseQueryResult<VehicleTripLog[], RemoteApiError>;
}
